var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconComplete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "checkmark",
    width: 137,
    height: 138,
    viewBox: "0 0 137 138",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#83bd3f",
    d: "M136.75 69.06c0 8.31-15.12 13.553-18.117 20.78-3.106 7.491 3.76 21.864-1.885 27.51-5.646 5.645-20.018-1.222-27.51 1.884-7.226 2.997-12.47 18.117-20.78 18.117s-13.552-15.12-20.778-18.117c-7.492-3.106-21.865 3.76-27.51-1.885-5.646-5.646 1.22-20.018-1.885-27.51C15.288 82.613.168 77.37.168 69.06s15.12-13.553 18.117-20.78c3.106-7.49-3.76-21.864 1.885-27.509 5.646-5.646 20.018 1.221 27.51-1.885C54.906 15.89 60.149.77 68.459.77s13.553 15.12 20.78 18.117c7.49 3.106 21.864-3.76 27.509 1.885 5.646 5.646-1.221 20.018 1.885 27.51 2.997 7.226 18.117 12.47 18.117 20.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "checkmark__check",
    d: "M59.954 91.685a2.443 2.443 0 0 1-1.727-.715L39.525 72.268a2.443 2.443 0 0 1 3.454-3.455l16.809 16.81 31.86-38.308a2.442 2.442 0 0 1 3.756 3.124L61.832 90.804a2.44 2.44 0 0 1-1.878.881z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconComplete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_complete.88111ba2.svg";
export { ForwardRef as ReactComponent };